import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
} from '@mui/material';
import { Block, ArrowBack } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Block sx={{ fontSize: 80, color: 'error.main' }} />
          </Box>

          <Typography component="h1" variant="h4" gutterBottom color="error">
            Access Denied
          </Typography>
          
          <Typography variant="body1" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
            You don't have permission to access this page.
          </Typography>

          {user && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Signed in as: <strong>{user.full_name}</strong> ({user.role})
            </Typography>
          )}

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={handleGoBack}
            >
              Go Back
            </Button>

            <Button
              variant="contained"
              onClick={handleGoHome}
            >
              Go to Dashboard
            </Button>
          </Box>

          <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              If you believe you should have access to this page, please contact your administrator.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Unauthorized;